<template>
    <span class="chat-online-status" :class="statusClass" :title="statusText">
        <span class="status-dot"></span>
        <span v-if="showLabel" class="status-label">{{ statusText }}</span>
    </span>
</template>

<script>
export default {
    name: 'ChatOnlineStatus',
    props: {
        isOnline: {
            type: Boolean,
            default: false
        },
        showLabel: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md',
            validator: (val) => ['sm', 'md', 'lg'].includes(val)
        }
    },
    computed: {
        statusClass() {
            return {
                'status-online': this.isOnline,
                'status-offline': !this.isOnline,
                [`status-${this.size}`]: true
            };
        },
        statusText() {
            return this.isOnline ? 'En ligne' : 'Hors ligne';
        }
    }
};
</script>

<style scoped>
.chat-online-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.status-dot {
    border-radius: 50%;
    flex-shrink: 0;
}

.status-online .status-dot {
    background-color: #22c55e;
    box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.status-offline .status-dot {
    background-color: #9ca3af;
}

.status-label {
    font-size: 12px;
    color: #6b7280;
}

.status-online .status-label {
    color: #22c55e;
}

/* Sizes */
.status-sm .status-dot {
    width: 6px;
    height: 6px;
}

.status-md .status-dot {
    width: 8px;
    height: 8px;
}

.status-lg .status-dot {
    width: 10px;
    height: 10px;
}
</style>
